import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { space, width } from 'styled-system';
var BaseImg = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: block;\n\tmax-width: 100%;\n\theight: auto;\n\t", ";\n\t", ";\n"], ["\n\tdisplay: block;\n\tmax-width: 100%;\n\theight: auto;\n\t", ";\n\t", ";\n"])), space, width);
BaseImg.displayName = 'Img';
export var Img = BaseImg;
var templateObject_1;
